import { Box, Grid, Typography, Paper } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect, ChangeEvent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formContainer: {
      padding: theme.spacing(2)
    },
    paper: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3)
    },
    mainTitle: {
      marginBottom: theme.spacing(3),
      fontWeight: 500
    },
    sectionTitle: {
      marginBottom: theme.spacing(2),
      fontWeight: 500
    }
  })
);

interface FormData {
  nomeApelidoNotificador: string;
  categoriaProfissional: string;
  telefone: string;
  email: string;
  dataNotificacao: string;
}

export default function Notificador() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const reduxData = useSelector((state: any) => state.dadosNotificador);
  const [formData, setFormData] = useState<FormData>(reduxData && Object.keys(reduxData).length > 0 ? reduxData : {
    nomeApelidoNotificador: '',
    categoriaProfissional: '',
    telefone: '',
    email: '',
  });
  const { control, trigger } = useFormContext();

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  useEffect(() => {
    dispatch({
      type: 'dadosNotificador',
      payload: formData
    });
  }, [formData, dispatch]);

  useEffect(() => {
    const handleValidateCurrentStep = (event: Event) => {
      const custom = event as CustomEvent;
      const stepIndex = custom?.detail?.stepIndex;
      if (stepIndex !== 4) return;
      trigger([
        'nomeApelidoNotificador',
        'categoriaProfissional',
        'telefone',
        'email'
      ]).then((isValid) => {
        window.dispatchEvent(new CustomEvent('validationResult', { detail: { isValid } }));
      });
    };
    window.addEventListener('validateCurrentStep', handleValidateCurrentStep);
    return () => window.removeEventListener('validateCurrentStep', handleValidateCurrentStep);
  }, [trigger]);

  return (
    <Box className={classes.formContainer}>

      {/* Dados do Notificador */}
      <Paper className={classes.paper} elevation={2}>
        <Typography variant="h6" className={classes.sectionTitle}>
          Dados do Notificador
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Controller
              name="nomeApelidoNotificador"
              control={control}
              defaultValue={formData.nomeApelidoNotificador}
              rules={{ required: 'Nome do notificador é obrigatório' }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label="Nome e Apelido"
                  fullWidth
                  // size="small"
                  id="notificadorNome"
                  variant="outlined"
                  error={!!error}
                  helperText={error ? error.message : ''}
                  onChange={(e) => {
                    field.onChange((e.target as HTMLInputElement).value);
                    handleChange(e);
                    trigger('nomeApelidoNotificador');
                  }}
                  value={field.value}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <Controller
              name="categoriaProfissional"
              control={control}
              defaultValue={formData.categoriaProfissional}
              rules={{ required: 'Profissão do notificador é obrigatória' }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label="Categoria Profissional"
                  fullWidth
                  // size="small"
                  id="categoriaProfissional"
                  variant="outlined"
                  placeholder="Ex: Médico, Farmacêutico, Enfermeiro"
                  error={!!error}
                  helperText={error ? error.message : ''}
                  onChange={(e) => {
                    field.onChange((e.target as HTMLInputElement).value);
                    handleChange(e);
                    trigger('categoriaProfissional');
                  }}
                  value={field.value}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <Controller
              name="telefone"
              control={control}
              defaultValue={formData.telefone}
              rules={{
                required: 'Telefone do notificador é obrigatório',
                pattern: { value: /^[0-9]{9}$/, message: 'Telefone do notificador deve ter 9 dígitos' }
              }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label="Telefone"
                  fullWidth
                  // size="small"
                  id="notificadorTel"
                  variant="outlined"
                  error={!!error}
                  helperText={error ? error.message : ''}
                  onChange={(e) => {
                    field.onChange((e.target as HTMLInputElement).value);
                    handleChange(e);
                    trigger('telefone');
                  }}
                  value={field.value}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <Controller
              name="email"
              control={control}
              defaultValue={formData.email}
              rules={{
                required: 'Email do notificador é obrigatório',
                pattern: { value: /\S+@\S+\.\S+/, message: 'Email do notificador inválido' }
              }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label="Email"
                  fullWidth
                  // size="small"
                  id="notificadorEmail"
                  variant="outlined"
                  error={!!error}
                  helperText={error ? error.message : ''}
                  onChange={(e) => {
                    field.onChange((e.target as HTMLInputElement).value);
                    handleChange(e);
                    trigger('email');
                  }}
                  value={field.value}
                />
              )}
            />
          </Grid>

        </Grid>
      </Paper>
    </Box>
  );
}